module.exports = __webpack_public_path__ + "static/media/cross_icon.951b71e5.svg";